module.exports = __webpack_public_path__ + "static/media/manageAuditorsAndRRRs.7b7c4d33.svg";